<template>
    <DCard
        padding
    >
        <DTable
            class="table-responsive"
            :items="form.types"
            :fields="[
                {key: 'name', label: __('settings.communication_subscription_types.table.name')},
                {key: 'active', label: __('settings.communication_subscription_types.table.active')},
                {key: 'subscription_rule', label: __('settings.communication_subscription_types.table.subscription_rule')},
                {key: 'action', label: ''}
            ]"
        >
            <template #name="{item}">
                <td>
                    {{ __('settings.communication_subscription_types.types.' + item.name) }}
                </td>
            </template>
            <template #active="{item}">
                <td>
                    <DSwitch
                        :id="'communication-subscription-types-' + item.name + '-enabled'"
                        v-model="item.active"
                        color="success"
                        variant="3d"
                        :disabled="communicationProvider === 'brevo'"
                    />
                </td>
            </template>
            <template #subscription_rule="{item}">
                <td>
                    <DSelect
                        :id="'communication-subscription-types-' + item.name + '-rule'"
                        v-model="item.subscription_rule"
                        :options="subscriptionRuleOptions"
                        :disabled="communicationProvider === 'brevo'"
                    />
                </td>
            </template>
            <template #action="{item}">
                <td>
                    <div>
                        <DButton
                            :id="`edit_${item.id}`"
                            mini
                            icon="pencil"
                            @click="openModal(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
    </DCard>
    <EditModal
        v-if="showEditModal"
        :show="showEditModal"
        :type="selectedType"
        :default-tenant-language="defaultTenantLanguage"
        :tenant-languages="tenantLanguages"
        @close-modal="showEditModal = false"
    />
    <DFabs v-if="communicationProvider !== 'brevo'">
        <DFab
            id="communication-subscription-types-save"
            icon="content-save"
            :label="__('messages.save')"
            :loading="form.processing"
            @click="save"
        />
    </DFabs>
</template>

<script setup>
import { useForm, usePage } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { computed, ref } from 'vue'
import EditModal from '~@/Components/Settings/CommunicationSubscriptionTypes/EditModal.vue'

const props = defineProps({
    types: {
        type: Array,
        default: () => []
    },
    defaultTenantLanguage: {
        type: Object,
        default: () => { return {} }
    },
    tenantLanguages: {
        type: Array,
        default: () => { return [] }
    },
    subscriptionRuleOptions: {
        type: Array,
        default: () => []
    }
})

const form = useForm({
    types: props.types.map(type => ({ ...type }))
})

const showEditModal = ref(false)
const selectedType = ref(null)
const communicationProvider = computed(() => usePage().props.tenantSettings?.communication_provider)

function openModal (item) {
    selectedType.value = item
    showEditModal.value = true
}

function save () {
    form
        .transform(data => ({
            types: data.types.map(type => ({
                id: type.id,
                active: type.active,
                subscription_rule: type.subscription_rule
            }))
        }))
        .patch(route('settings.communication-subscription-types.bulk-update'), {
            preserveScroll: true
        })
}
</script>
